import axios from 'axios';
import ENV_CONFIG from '../config/environment-unified';

// const api = axios.create({
//   baseURL: ENV_CONFIG.EVENTS_ENDPOINT,
//   withCredentials: true,
//   headers: {
//     'Content-Type': 'application/json'
//   }
// });

export const eventService = {
  // Step 1: Create Draft
  createDraft: async (data) => {
    const response = await axios.post(`${ENV_CONFIG.EVENTS_ENDPOINT}/init`, data, {
      withCredentials: true
    });
    return response.data;
  },

  // Step 2: Set Category & Setup
  setupCategory: async (slug, categoryId) => {
    const response = await axios.put(`${ENV_CONFIG.EVENTS_ENDPOINT}/${slug}/setup`,
      { categoryId },
      { withCredentials: true }
    );
    return response.data;
  },

  // Step 3: Configuration
  configureEvent: async (slug, configData) => {
    const response = await axios.put(`${ENV_CONFIG.EVENTS_ENDPOINT}/${slug}/config`,
      configData,
      { withCredentials: true }
    );
    return response.data;
  },

  // Step 4: Streamer Assignment
  assignStreamer: async (slug, streamerData) => {
    const response = await axios.post(`${ENV_CONFIG.EVENTS_ENDPOINT}/${slug}/streamers`,
      streamerData,
      { withCredentials: true }
    );
    return response.data;
  },

  // User search for tournament invitations
  searchUsers: async (term) => {
    const response = await axios.get(`${ENV_CONFIG.EVENTS_ENDPOINT}/users/search`, {
      params: { term },
      withCredentials: true
    });
    return response.data;
  },

  // Get Event Details
  getEvent: async (slug) => {
    const response = await axios.get(`${ENV_CONFIG.EVENTS_ENDPOINT}/events/${slug}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Get Categories
  getCategories: async () => {
    const response = await axios.get(`${ENV_CONFIG.EVENT_CATEGORIES_ENDPOINT}`, {
      withCredentials: true
    });
    return response.data;
  },

  // Publish Event
  publishEvent: async (slug) => {
    const response = await axios.post(`${ENV_CONFIG.EVENTS_ENDPOINT}/${slug}/publish`, {}, {
      withCredentials: true
    });
    return response.data;
  }
};

